
  import { throttle } from 'throttle-debounce';
  import { isInClipFlyAppBrower } from '~/utils/common';
  export default {
    data () {
      return {
        isInClipFlyApp: false,
      }
    },
    props: {
      info: {
        type: Object,
        default () {
          return {
            show: false,
            title: "",
            content: "",
            cancelBtnText: "Cancel",
            confirmBtnText: "OK",
            cancelBtnClick: () => { },
            confirmBtnClick: () => { },
          }
        }
      }
    },
    mounted () {
      if (process.client && isInClipFlyAppBrower()) {
        this.isInClipFlyApp = true;
      } else {
        this.isInClipFlyApp = false;
      }
    },
    methods: {
      btnCancel: throttle(1000, function() {
        this.info.cancelBtnClick && this.info.cancelBtnClick()
      }),
      btnConfirm: throttle(1000, function() {
        this.info.confirmBtnClick && this.info.confirmBtnClick()
      }),
    }
  }
